__turbopack_context__.v({
  "close": "MXs1kq_close",
  "icon": "MXs1kq_icon",
  "item": "MXs1kq_item",
  "message": "MXs1kq_message",
  "root": "MXs1kq_root",
});
